import type { ServerStatus } from "@woven/contracts";
import type { StatusTone } from "../components/ui/StatusIndicator";

const STATUS_TONE: Record<ServerStatus, StatusTone> = {
  pending: "warn",
  provisioning: "info",
  running: "ok",
  stopping: "warn",
  stopped: "neutral",
  degraded: "warn",
  failed: "danger",
};

/** Maps a real server status to its display tone. */
export function statusTone(status: ServerStatus): StatusTone {
  return STATUS_TONE[status];
}
